export const expirationArray = ["", "/", ""];

export const pushPlaceOrderEventToGTM = (transaction, gtmProducts) => {
  window.dataLayer.push({
    event: "purchase",
    transactionId: transaction.orderNumber,
    transactionAffiliation: "Online Store",
    transactionTotal: transaction.total,
    transactionTax: transaction.taxCost,
    transactionProducts: gtmProducts
  });
};
